import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Box } from '@mui/material'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import { useGlobalShortcuts } from './hooks/useKeyboardShortcuts'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Deposits from './pages/Deposits'
import Withdrawals from './pages/Withdrawals'
import SmsRequests from './pages/SmsRequests'
import Reports from './pages/Reports'
import Comparators from './pages/Comparators'
import UserActivity from './pages/UserActivity'
import InactiveUsers from './pages/InactiveUsers'
import UserManagement from './pages/UserManagement'
import Configuration from './pages/Configuration'
import SystemInfo from './pages/SystemInfo'
import Unauthorized from './pages/Unauthorized'
import TransactionQueue from './pages/TransactionQueue'
import AuditTrail from './pages/AuditTrail'
import FraudDetection from './pages/FraudDetection'
import Reconciliation from './pages/Reconciliation'

function AppContent() {
  useGlobalShortcuts()

  return (
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/deposits" element={<Deposits />} />
                      <Route path="/withdrawals" element={<Withdrawals />} />
                      <Route path="/sms-requests" element={<SmsRequests />} />
                      <Route path="/reports" element={<Reports />} />
                      <Route path="/comparators" element={<Comparators />} />
              <Route path="/queue" element={<TransactionQueue />} />
              <Route path="/audit-trail" element={<AuditTrail />} />
              <Route
                path="/fraud-detection"
                element={
                  <ProtectedRoute allowedRoles={['super_admin']}>
                    <FraudDetection />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reconciliation"
                element={
                  <ProtectedRoute allowedRoles={['super_admin']}>
                    <Reconciliation />
                  </ProtectedRoute>
                }
              />
                      <Route path="/users" element={<UserActivity />} />
                      <Route path="/users/inactive" element={<InactiveUsers />} />
                      <Route
                        path="/configuration"
                        element={
                          <ProtectedRoute allowedRoles={['super_admin']}>
                            <Configuration />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/system"
                        element={
                          <ProtectedRoute allowedRoles={['super_admin']}>
                            <SystemInfo />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/admin/users"
                        element={
                          <ProtectedRoute allowedRoles={['super_admin']}>
                            <UserManagement />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </Layout>
                </Box>
  )
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppContent />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App

